import React from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import string from "LIB/strings";

export class SpecialInstructions extends React.Component {
  render() {
    const { resource } = this.props;

    if (string(resource.get("special_instructions")).empty()) return null;

    return (
      <div>
        <div>
          <hr className="hr-dashed" />
          <h2>Special Instructions</h2>
        </div>
        <div
          className="panel panel-default panel-note"
          style={{ marginBottom: 2 }}
        >
          <div
            className="panel-collapse collapse in"
            aria-labelledby="headingOne"
          >
            <div className="panel-body" style={{ padding: "8px 15px" }}>
              <span>{resource.get("special_instructions")}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SpecialInstructions.propTypes = {
  resource: PropTypes.instanceOf(Map).isRequired
};

export default SpecialInstructions;



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/shared/SpecialInstructions/SpecialInstructions.jsx